export class CurrentInspectionTemplateError extends Error {
  constructor(
    message: string = 'Failed to fetch current inspection template',
    options?: ErrorOptions
  ) {
    super(message, options);
    this.name = 'CurrentInspectionTemplateError';
  }
}
